/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-01-23 16:23:35
 * @LastEditTime: 2025-04-07 17:52:39
 * @LastEditors: ywj@originqc.com
 */
import React from 'react'
import { serviceData} from '../config';
import './index.scss';

interface ISProps{
  pic: string,
  name: string,
  id:number
}
function Service() {
  return (
    <div className='service-container'>
      {
        serviceData.map((item:ISProps) => { 
          return (
            <div className='service-item' key={item.id}>
              <p className='service-text'>
                <img className='pic' src={item.pic} alt='icon' />
               <span> {item.name}</span>
              </p>
            </div>
          )
        })}
    </div>
  )
}

export default Service;